import React, { useContext } from "react";
import "./Common_Category_Card.css";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";

const Common_Category_Card = (props) => {
  const navigate = useNavigate();

  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);

  return (
    <section
      className="Common_Category_Card"
      onClick={() => {
        navigate(props?.goto);
      }}
    >
      <div className={`outer_colored_card `} style={{ backgroundColor: props?.theme_colour }}>
        <div className="img_holder">
          <img src={IMG_URL + props?.prodImg} className="prod_img" />
        </div>

        <div className="text_holder">
          <p className="prod_name" style={{ backgroundColor: props?.button_colour }}>{props?.prodName}</p>
        </div>
      </div>
    </section>
  );
};

export default Common_Category_Card;
